import request from "@/utils/request";

export default function openCloseShopLookNum(id, isShowLookNum) {
    return request({
        url: `/storeShop/agency/openCloseLookNum/`+id+`/`+isShowLookNum,
        method: 'get',
    })
}
